import { Chart } from "react-google-charts";
import React, { useState, useEffect } from "react";
import { Row, Col, Table, Card, Form, Button, Spinner } from 'react-bootstrap';
import { useProvider, Toast } from '../../context/MenuProvider';
import { Link, useNavigate, useParams } from 'react-router-dom';


const GraficoBarraCategoria = () => {
  const { 
    setLinks, 
    setBtns,
    hasPerms,
    crud,
  } = useProvider();
  const [isQuantidade, setIsQuantidade] = useState(false);
  const [isSoQuantidade, setIsSoQuantidade] = useState(false);
  const [dadosGrafico, setDadosGrafico] = useState([]);
  const [opcoes, setOpcoes] = useState({});
  const [mesAno, setMesAno] = useState({});
  const { id, tipo, categoria, modelo } = useParams();
  const [ano, mes] = new Intl.DateTimeFormat('sv-SE', {
    year: 'numeric',
    month: '2-digit',
  }).format(new Date()).split('-');
  
  useEffect(()=>{
    setMesAno({
      ano,
      mes
    });
  },[ano,mes]);
  
  const { get } = crud || {};
  
  const processTipo = (input) => {
    if (!input) return ""; // se vazio, retorna string vazia
  
    // garante array de itens sem espaços vazios
    let itens = (typeof input === "string" ? input : input.join(","))
      .split(",")
      .map(s => s.trim())
      .filter(Boolean);
  
    if (itens.includes("pessoais") && !hasPerms(["financas.view_financeiro"])) {
      itens = itens.filter(i => i !== "pessoais");
    }
    if (itens.includes("negocio") && !hasPerms(["loja.view_venda"])) {
      itens = itens.filter(i => i !== "negocio");
    }
    if (itens.includes("produtos") && !hasPerms(["loja.view_venda"])) {
      itens = itens.filter(i => i !== "produtos");
    }
    if (itens.includes("venda") && !hasPerms(["loja.view_venda"])) {
      itens = itens.filter(i => i !== "venda");
    }
    if (itens.includes("rede") && !hasPerms(["rede.view_prospecto","rede.view_consultor", "rede.view_apn"])) {
      itens = itens.filter(i => i !== "rede");
    }
  
    return itens.join(",");
  };  
  
  const tipos = processTipo(tipo);
  
  useEffect(()=>{
    switch(tipo){
      case 'produtos':
        setIsQuantidade(true);
        break
      case 'rede':
        setIsQuantidade(true);
        setIsSoQuantidade(true);
        break
    }
  },[tipo])
  
  const data = new Date(parseInt(mesAno?.ano || ano), (mesAno?.mes || mes) - 1);
  const mesNome = new Intl.DateTimeFormat('pt-BR', { month: 'long' }).format(data);
  const mesAnoNome = `${mesNome.charAt(0).toUpperCase() + mesNome.slice(1)}/${mesAno?.ano}`;
  
  const gerarEstruturaInicial = () => ([
    ["Categoria", mesAnoNome],
  ]);

  useEffect(() => {
    buscarBalancoDiario();
  }, [isQuantidade, mesAno]);

  const buscarBalancoDiario = async () => {
    const novaData = gerarEstruturaInicial();
    

    try {
      const response = await get(
        `gvendas/metas/?categoria__tipo__in=${tipos}&is_quantidade=${isQuantidade}&ano=${mesAno?.ano||ano}&mes=${mesAno?.mes||mes}&expand=categoria&filtros=nome,alcancado,ano,mes`,
        "gbarras"
      );

      if (response && response.length) {
        
        for (const item of response[0].results) {
          const mesIndex = item.mes;
          const catNome = item.categoria?.nome;
          const valor = parseFloat(item.alcancado);
          
          novaData.push([catNome, valor]);
        }
        
        if(!response[0].results.length){
          novaData.push([null, 0]);
        }
        setDadosGrafico(novaData);

        setOpcoes({
          title: `Todas as metas de ${tipo}`,
          chartArea: { width: "50%" },
          hAxis: {
            title: isQuantidade ? "Quantidade" : "Valor",
            minValue: 0,
          },
          vAxis: {
            title: "Categorias",
          },
          bars: "horizontal",
          series: {
            0: { color: "#0984e3" },
            1: { color: "#b2bec3" },
            2: { color: "#636e72" },
          },
        });
      }
    } catch (err) {
      //alert("Erro ao buscar dados: " + JSON.stringify(err.response || err));
    }
  };
  
  const anos = Array.from({ length: new Date().getFullYear() - 2024 + 1 }, (_, i) => 2024 + i);
  const mesesDoAno = [
    { valor: '01', nome: 'Janeiro' },
    { valor: '02', nome: 'Fevereiro' },
    { valor: '03', nome: 'Março' },
    { valor: '04', nome: 'Abril' },
    { valor: '05', nome: 'Maio' },
    { valor: '06', nome: 'Junho' },
    { valor: '07', nome: 'Julho' },
    { valor: '08', nome: 'Agosto' },
    { valor: '09', nome: 'Setembro' },
    { valor: '10', nome: 'Outubro' },
    { valor: '11', nome: 'Novembro' },
    { valor: '12', nome: 'Dezembro' },
  ];

  return (
    <>
      <Form.Group controlId="formMesAno" className="mt-3">
        <div className="input-group">
          <span className="input-group-text">Mês</span>
          <Form.Control 
            as="select" 
            value={mesAno?.mes || ''} 
            onChange={(e) => 
              setMesAno((prevItem) => ({
                ...prevItem,
                mes: e.target.value
              }))
            }
          >
            <option value="">{'Selecione um mês'}</option>
            {mesesDoAno.map((mes) => (
              <option key={mes.valor} value={mes.valor}>
                {mes.nome}
              </option>
            ))}
          </Form.Control>
          <span className="input-group-text">Ano</span>
          <Form.Control 
            as="select" 
            value={mesAno?.ano || ''} 
            onChange={(e) => 
              setMesAno((prevItem) => ({
                ...prevItem,
                ano: e.target.value
              }))
            }
          >
            <option value="">{'Selecione um ano'}</option>
            {anos.map((ano) => (
              <option key={ano} value={ano}>
                {ano}
              </option>
            ))}
          </Form.Control>
        </div>
      </Form.Group>
      {!isSoQuantidade && (
          <Form.Group controlId="formIsQuantidade" className="fs-5">
            <Form.Check 
              type="switch" 
              label="Por Quantidade"
              checked={isQuantidade}
              onChange={(e) => setIsQuantidade(e.target.checked)} 
            />
          </Form.Group>
      )}
      {dadosGrafico.length > 0 && (
        <Chart
          chartType="BarChart"
          width="100%"
          height="600px"
          data={dadosGrafico}
          options={opcoes}
        />
      )}
    </>
  );
};

export default GraficoBarraCategoria;